// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3AllW","col":"Table_col__37KyW","fulfillmentStatus":"Table_fulfillmentStatus__3sZOo","emailCol":"Table_emailCol__2Q3DK"};